<template>
    <div class="flex items-center gap-x-3">
        <div
            class="size-2 rounded-full"
            :class="data.colour"
        />
        <span v-text="$filters.capitalize(data.name)" />
    </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        required: true,
    },
});
</script>
